module.exports = __webpack_public_path__ + "img/logo1.f17977f0.png";